var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEnter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17267 4.38848C4.79125 4.73523 4.20875 4.73523 3.82733 4.38848L0.913936 1.73994C0.237606 1.1251 0.672575 1.53492e-07 1.58661 2.37373e-07L7.41339 7.72098e-07C8.32743 8.55979e-07 8.76239 1.1251 8.08607 1.73994L5.17267 4.38848Z",
    fill: "#1B203D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnter);
export default __webpack_public_path__ + "static/media/icon-enter.2a763613b1da140d1f2c83023805198d.svg";
export { ForwardRef as ReactComponent };